if (!process.env.VUE_APP_IS_WEB) {
  var BuildingOwnerVotingRightDB = require("../database/models/BuildingOwnerVotingRight");
}
import dates from "@/database/dates";
import strings from "@/database/strings";

import BuildingOwnerVotingRightORM from "@/store/orm-axios/models/BuildingOwnerVotingRight";

export default {
  POST(item) {
    // permanet set the aagency id in desktop and web version
    item["agency_id"] = Number(localStorage.getItem("agencyId"));

    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new BuildingOwnerVotingRightDB(itemPost)
          .save()
          .then(res => {
            BuildingOwnerVotingRightORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerVotingRightORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new BuildingOwnerVotingRightDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            BuildingOwnerVotingRightORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerVotingRightORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new BuildingOwnerVotingRightDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            BuildingOwnerVotingRightORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerVotingRightORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
